import React, { useEffect } from 'react';

import { useMediaPlayer } from '../MediaPlayerProvider';

/**
 * plays videos inline instead of open them in fullscreen mode in mobile browsers.
 */
export const PlaysInlineMode: React.FC = () => {
  const { player } = useMediaPlayer();
  useEffect(() => {
    if (player !== null) {
      player.playsinline(true);
    }
  }, [player]);
  return null;
};
